import React from 'react';
import { Icon, Image, List } from '@landing/ui';

import * as styles from './Slide.module.scss';

export default function Slide({ description, list, img, name, position, linkedin }) {
  return (
    <div className={styles.slide}>
      {description && <p className={styles.description}>{description}</p>}
      <List className={styles.list} items={list} />
      <figure className={styles.figure}>
        <Image className={styles.picture} classImage={styles.img} src={img} />
        <figcaption className={styles.figcaption}>
          <a
            className={styles.link}
            href={linkedin}
            target="_blank"
            rel="noreferrer noopener noindex nofollow"
          >
            <span className={styles.name}>{name}</span>{' '}
            <Icon className={styles.linkedinIcon} name="linkedin" />
          </a>
          <p className={styles.position}>{position}</p>
        </figcaption>
      </figure>
    </div>
  );
}
